import React from 'react';
import Header from '../../components/ui/Header';
import SustainabilityHero from './components/SustainabilityHero';
import SolarEnergySection from './components/SolarEnergySection';
import EnvironmentalBenefits from './components/EnvironmentalBenefits';
import FutureVision from './components/FutureVision';

const Sustainability = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="pt-16">
        <SustainabilityHero />
        <SolarEnergySection />
        <EnvironmentalBenefits />
        <FutureVision />
      </div>
    </div>
  );
};

export default Sustainability;
